import { ChevronRight } from "@tamagui/lucide-icons";
import { JSX } from "react";
import { GetProps, XStack, YStack } from "tamagui";

import { Button } from "@/components/Button";
import { Heading, Text } from "@/components/Typography";
import { getShadow } from "@/theme/helpers";

interface ActionCardProps extends GetProps<typeof XStack> {
  title: string;
  titleProps?: GetProps<typeof Heading>;
  description?: string;
  descriptionProps?: GetProps<typeof Text>;
  icon?: JSX.Element;
  iconAfter?: JSX.Element;
  onPress: () => void;
  dataTrackingId?: string;
  extraTrackingContext?: Record<string, string>;
}

export default function ActionCard({
  title,
  titleProps,
  description,
  descriptionProps,
  onPress,
  icon,
  iconAfter = <ChevronRight color="$iconSecondary" flexShrink={0} />,
  dataTrackingId = "action-card",
  ...props
}: ActionCardProps) {
  return (
    <Button.Wrapper
      dataTrackingId={dataTrackingId}
      aria-label={title}
      onPress={onPress}
      alignItems="center"
      justifyContent="center"
      gap="$100"
      backgroundColor="$fillCallout"
      borderRadius="$150"
      paddingHorizontal="$250"
      paddingVertical="$200"
      {...getShadow()}
      {...props}
    >
      {icon}
      <YStack flex={1} gap="$100">
        <Heading {...titleProps}>{title}</Heading>
        {Boolean(description) && (
          <Text size="$sm" color="$textSecondary" {...descriptionProps}>
            {description}
          </Text>
        )}
      </YStack>
      {iconAfter}
    </Button.Wrapper>
  );
}
